module.exports = __webpack_public_path__ + "static/img/emoji_4.d7487bfd.png";